// extracted by mini-css-extract-plugin
export default {"container":"homepage_container__EIG-D"};